import React from "react";
import './Body4.css';
import Box1 from "./Box1";
import picture40 from './source/picture40.png'
import picture41 from './source/picture41.png'
import picture42 from './source/picture42.png'
import picture43 from './source/picture43.png'
import picture44 from './source/picture44.png'
import picture45 from './source/picture45.png'



function Body4() {

  return (
    <div className="body4">
      <div className="body4-box1">
        <div className="body4-box2">
          <div className="body4-box3">Nabídka služeb</div>
          <div className="body4-box5"><div className="body4-box4"></div></div>
          <div className="body4-box6">
          <Box1 ImgBox1={picture40} NadpisBox1='Sádrokartony' PopisBox1='Základem suchého způsobu zdění jsou sádrokartonové desky, díky kterým lze levně rekonstruovat, upravit nebo zateplit interiér.'/>
          <Box1 ImgBox1={picture41} NadpisBox1='Půdní vestavby' PopisBox1='Půdní vestavba je ideální možností, jak získat zcela nový prostor k životu, který je vždy šitý přesně na míru každému domu a majiteli.'/>
          <Box1 ImgBox1={picture42} NadpisBox1='Dřevostavby' PopisBox1='Nabízíme opláštění dřevostaveb. Opláštění slouží k ochraně konstrukce před povětrnostními vlivy a zároveň může zlepšit estetický vzhled budovy.'/>
          <Box1 ImgBox1={picture44} NadpisBox1='Suché podlahy' PopisBox1='Suché podlahy nevyužívají při své realizaci mokrý proces. Svojí nízkou váhou nezatěžují dřevěné stropy a jsou pro ně ideální. Dají se použít kdekoliv i na nerovný povrch. '/>
          <Box1 ImgBox1={picture45} NadpisBox1='Kazetové podhledy' PopisBox1='Kazetové podhledy uspokojí nejvyšší nároky na estetiku, akustiku, mechanickou odolnost a dlouhodobou životnost v moderních kancelářích, školách nebo školkách.'/>
          <Box1 ImgBox1={picture43} NadpisBox1='Sádrové stěrky (Semin)' PopisBox1='Semin jsou produkty určené pro vnitřní úpravy stěn a stropů, zejména pro vyrovnání a finální úpravu povrchu. Jemná konzistence, snadné broušení a dobrá přilnavost.'/>
          </div>
        </div> 
      </div> 
    </div>
  );
}

export default Body4;
